import { useTranslation } from 'react-i18next';

import { MasterTable, type MasterTableColumn } from '@/components/efs/MasterTable';
import { Badge } from '@/components/ui/badge';
import type { SourceFileDto } from '../types';

interface SourceFileTableProps {
  rows: SourceFileDto[];
  isLoading?: boolean;
}

export const SourceFileTable = ({ rows, isLoading }: SourceFileTableProps) => {
  const { t } = useTranslation();

  const columns: MasterTableColumn<SourceFileDto>[] = [
    {
      key: 'original_file_name',
      header: t('efs.imports.dropzone.file_name', { ns: 'imports' }),
      cell: (row) => <span className="font-mono text-xs">{row.original_file_name}</span>,
    },
    {
      key: 'source_file_type',
      header: t('efs.imports.review.fields.status', { ns: 'imports' }),
      cell: (row) =>
        t(`efs.imports.source_types.${row.source_file_type}`, {
          ns: 'imports',
          defaultValue: row.source_file_type,
        }),
    },
    {
      key: 'parsed_status',
      header: t('efs.imports.statuses.parsed', { ns: 'imports' }),
      cell: (row) => (
        <Badge variant={row.parsed_status === 'parsed' ? 'default' : 'secondary'}>
          {t(`efs.imports.statuses.${row.parsed_status}`, {
            ns: 'imports',
            defaultValue: row.parsed_status,
          })}
        </Badge>
      ),
    },
    {
      key: 'file_hash',
      header: t('efs.imports.dropzone.file_hash', { ns: 'imports' }),
      cell: (row) => (
        <span className="font-mono text-xs text-efs-text-muted">{row.file_hash.slice(0, 12)}…</span>
      ),
    },
    {
      key: 'uploaded_at',
      header: t('efs.imports.dropzone.uploaded_at', { ns: 'imports' }),
      cell: (row) => <span className="text-xs">{row.uploaded_at}</span>,
    },
  ];

  return (
    <MasterTable
      columns={columns}
      rows={rows}
      rowKey={(row) => row.source_file_id}
      isLoading={isLoading}
      emptyMessage={t('efs.imports.source_files.empty', { ns: 'imports' })}
    />
  );
};
